export function buildModalTab(props, params) {
    var _a;
    const children = [
        {
            type: 'form.text',
            key: 'modal.title',
            label: 'Modal Title',
            description: 'By default modal title is the same as label',
            emptyAsNull: true,
        },
        {
            type: 'form.text',
            key: 'modal.cancelButtonLabel',
            label: 'Cancel Button Label',
            description: 'Default: Cancel',
            emptyAsNull: true,
        },
        {
            type: 'form.text',
            key: 'modal.saveButtonLabel',
            label: 'Save Button Label',
            description: 'Default: Save',
            emptyAsNull: true,
        },
        {
            type: 'form.select',
            key: 'modal.maxWidth',
            label: 'Max Width',
            values: [
                { value: 'xs', label: 'Extra Small' },
                { value: 'sm', label: 'Small' },
                { value: 'md', label: 'Medium' },
                { value: 'lg', label: 'Large' },
                { value: 'xl', label: 'Extra Large' },
                { value: 'full', label: 'Full' },
            ],
            style: {
                width: 200,
            },
        },
        {
            type: 'form.checkbox',
            key: 'modal.fullWidth',
            label: 'Full Width',
        },
        ...((_a = params === null || params === void 0 ? void 0 : params.children) !== null && _a !== void 0 ? _a : []),
    ];
    const onLoad = (data) => {
        if (params === null || params === void 0 ? void 0 : params.onLoad) {
            data = params.onLoad(data);
        }
        return data;
    };
    const onSubmit = (data) => {
        if (params === null || params === void 0 ? void 0 : params.onSubmit) {
            data = params.onSubmit(data);
        }
        return data;
    };
    return { label: 'Modal', children, onLoad, onSubmit };
}
